<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pb-0">
        <analises-setorizadas-navigation-tabs :selectedTab.sync="selectedTabNavegationTabs" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <analises-setorizadas-data-table
          ref="analisesSetorizadasDataTable"
          :titulo="tituloTabela"
          :items="items"
          :loading="loading"
          @rechargeTable="chargeTableDecision(tipoListaAnaliseSetorizada)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AnalisesSetorizadasService from '@/services/AnalisesSetorizadasService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      AnalisesSetorizadasNavigationTabs: () => import('@/components/analises-setorizadas/AnalisesSetorizadasNavigationTabs'),
      AnalisesSetorizadasDataTable: () => import('@/components/analises-setorizadas/AnalisesSetorizadasDataTable')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      tituloTabela: 'Análises Setorizadas',
      selectedTabNavegationTabs: 0,
      loading: false
    }),

    computed: {
      tipoListaAnaliseSetorizada() {
        return this.$store.getters.getTipoListaAnaliseSetorizada;
      }
    },

    created() {
      this.chargeTableDecision(this.tipoListaAnaliseSetorizada);
    },

    methods: {
      getAnalisesSetorizadas() {
        this.items = [];
        this.loading = true;
        AnalisesSetorizadasService.index()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      getAnalisesSetorizadasFavoritadas() {
        this.items = [];
        this.loading = true;
        AnalisesSetorizadasService.getAnalisesSetorizadasFavoritadas()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      chargeTableDecision(newDecisionInfo) {
        if (this.$refs.analisesSetorizadasDataTable) {
          this.$refs.analisesSetorizadasDataTable.page = 1;
        }
        this.tituloTabela = newDecisionInfo.titulo;

        switch (newDecisionInfo.tipo) {
          case 'favoritos':
            this.selectedTabNavegationTabs = 1;
            this.cancelRefreshData();
            this.refreshData(this.getAnalisesSetorizadasFavoritadas);
            break;
          case 'historico':
          default:
            this.selectedTabNavegationTabs = 0;
            this.cancelRefreshData();
            this.refreshData(this.getAnalisesSetorizadas);
            break;
        }
      }
    },

    watch: {
      tipoListaAnaliseSetorizada(newValue) {
        this.chargeTableDecision(newValue);
      }
    }
  };
</script>
